module.exports = __webpack_public_path__ + "static/media/Career Center Logo.9e2df7b0.png";